/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Payments JSON Schemas 

const _INVOICE_JSON_SCHEMA = {
    "$ref": "#/definitions/InvoiceSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "InvoiceSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "invoice_item_uids": {
                    "items": {
                        "title": "invoice_item_uids",
                        "type": "string"
                    },
                    "maxItems": 500,
                    "reference_type": "uuid",
                    "title": "Invoice Item Uids",
                    "type": "array",
                    "uid_resource_type": "invoice_item"
                },
                "invoice_uid": {
                    "reference_type": "uuid",
                    "title": "Invoice Uid",
                    "type": "string",
                    "uid_resource_type": "invoice"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "state": {
                    "class_name": "InvoiceState",
                    "enum": [
                        "no_invoice_items",
                        "awaiting_payment",
                        "partial_payment",
                        "cancelled",
                        "paid",
                        "payment_failed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "total_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total In Cents",
                    "type": "number"
                },
                "total_left_to_pay_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total Left To Pay In Cents",
                    "type": "number"
                }
            },
            "required": [
                "created_timestamp",
                "deposify_tags",
                "description",
                "funds_location",
                "funds_location_uid",
                "invoice_item_uids",
                "invoice_uid",
                "last_updated_timestamp",
                "recipient_account_uid",
                "resource_type",
                "resource_uid",
                "state",
                "title",
                "total_in_cents",
                "total_left_to_pay_in_cents"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _INVOICE_ITEM_JSON_SCHEMA = {
    "$ref": "#/definitions/InvoiceItemSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "InvoiceItemSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "cost_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Cost In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "funds_lock_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Lock Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock"
                },
                "invoice_item_uid": {
                    "reference_type": "uuid",
                    "title": "Invoice Item Uid",
                    "type": "string",
                    "uid_resource_type": "invoice_item"
                },
                "invoice_uid": {
                    "reference_type": "uuid",
                    "title": "Invoice Uid",
                    "type": "string",
                    "uid_resource_type": "invoice"
                },
                "item_state": {
                    "class_name": "InvoiceItemState",
                    "enum": [
                        "awaiting_payment",
                        "paid",
                        "cancelled",
                        "payment_failed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "title": {
                    "title": "Title",
                    "type": "string"
                }
            },
            "required": [
                "cost_in_cents",
                "created_timestamp",
                "description",
                "funds_lock_uid",
                "invoice_item_uid",
                "invoice_uid",
                "item_state",
                "last_updated_timestamp",
                "recipient_account_uid",
                "resource_type",
                "resource_uid",
                "title"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _LOAN_JSON_SCHEMA = {
    "$ref": "#/definitions/LoanSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "LoanSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "attached_files_uid": {
                    "title": "Attached Files Uid",
                    "type": "string"
                },
                "completed_payment_period_count": {
                    "format": "integer",
                    "title": "Completed Payment Period Count",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Deposit Amount In Cents",
                    "type": "number"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "fees_total_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Fees Total Amount In Cents",
                    "type": "number"
                },
                "fees_total_amount_in_cents_per_period": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Fees Total Amount In Cents Per Period",
                    "type": "number"
                },
                "last_payment_failed_email_sent_timestamp": {
                    "format": "date-time",
                    "title": "Last Payment Failed Email Sent Timestamp",
                    "type": "string"
                },
                "last_payment_timestamp": {
                    "format": "date-time",
                    "title": "Last Payment Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_application_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Application Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "loan_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Uid",
                    "type": "string",
                    "uid_resource_type": "loan"
                },
                "most_recent_stripe_charge_id": {
                    "title": "Most Recent Stripe Charge Id",
                    "type": "string"
                },
                "most_recent_stripe_invoice_id": {
                    "title": "Most Recent Stripe Invoice Id",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "paid_to_date_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Paid To Date In Cents",
                    "type": "number"
                },
                "payment_failed_email_count": {
                    "format": "integer",
                    "title": "Payment Failed Email Count",
                    "type": "number"
                },
                "payment_period_count_for_loan": {
                    "format": "integer",
                    "title": "Payment Period Count For Loan",
                    "type": "number"
                },
                "payment_period_type": {
                    "class_name": "LoanPaymentPeriodType",
                    "enum": [
                        "none",
                        "monthly"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "payment_provider_type": {
                    "class_name": "PaymentType",
                    "enum": [
                        "stripe",
                        "priority_ach"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "payment_type": {
                    "class_name": "LoanPaymentType",
                    "enum": [
                        "once_off",
                        "recurring"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "priority_ach_recurring_payment_uid": {
                    "reference_type": "uuid",
                    "title": "Priority Ach Recurring Payment Uid",
                    "type": "string",
                    "uid_resource_type": "priority_ach_recurring_payment"
                },
                "state": {
                    "class_name": "LoanState",
                    "enum": [
                        "pending",
                        "active",
                        "payment_details_needed",
                        "complete",
                        "delinquent"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "stripe_payment_method_id": {
                    "title": "Stripe Payment Method Id",
                    "type": "string"
                },
                "stripe_subscription_auto_cancel_timestamp": {
                    "format": "date-time",
                    "title": "Stripe Subscription Auto Cancel Timestamp",
                    "type": "string"
                },
                "stripe_subscription_deleted": {
                    "title": "Stripe Subscription Deleted",
                    "type": "boolean"
                },
                "stripe_subscription_deleted_timestamp": {
                    "format": "date-time",
                    "title": "Stripe Subscription Deleted Timestamp",
                    "type": "string"
                },
                "stripe_subscription_id": {
                    "title": "Stripe Subscription Id",
                    "type": "string"
                },
                "total_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total Amount In Cents",
                    "type": "number"
                },
                "total_amount_in_cents_per_period": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total Amount In Cents Per Period",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "completed_payment_period_count",
                "deposit_amount_in_cents",
                "deposit_uid",
                "fees_total_amount_in_cents",
                "fees_total_amount_in_cents_per_period",
                "last_payment_failed_email_sent_timestamp",
                "last_payment_timestamp",
                "loan_application_uid",
                "loan_uid",
                "most_recent_stripe_charge_id",
                "most_recent_stripe_invoice_id",
                "paid_to_date_in_cents",
                "payment_failed_email_count",
                "payment_period_count_for_loan",
                "payment_period_type",
                "payment_provider_type",
                "payment_type",
                "priority_ach_recurring_payment_uid",
                "state",
                "stripe_payment_method_id",
                "stripe_subscription_auto_cancel_timestamp",
                "stripe_subscription_deleted",
                "stripe_subscription_deleted_timestamp",
                "stripe_subscription_id",
                "total_amount_in_cents",
                "total_amount_in_cents_per_period"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _LOAN_APPLICATION_JSON_SCHEMA = {
    "$ref": "#/definitions/LoanApplicationSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "LoanApplicationSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "application_uid": {
                    "reference_type": "uuid",
                    "title": "Application Uid",
                    "type": "string",
                    "uid_resource_type": "loan_application"
                },
                "archived": {
                    "title": "Archived",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Deposit Amount In Cents",
                    "type": "number"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Uid",
                    "type": "string",
                    "uid_resource_type": "loan"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "state": {
                    "class_name": "LoanApplicationState",
                    "enum": [
                        "pending",
                        "approved",
                        "declined",
                        "user_cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "application_uid",
                "archived",
                "deposit_amount_in_cents",
                "deposit_uid",
                "loan_uid",
                "state"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _LOAN_HISTORY_JSON_SCHEMA = {
    "$ref": "#/definitions/LoanHistorySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "LoanHistorySchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "entry_type": {
                    "class_name": "LoanHistoryEntryType",
                    "enum": [
                        "initial_creation",
                        "payment_succeeded",
                        "payment_failed",
                        "period_and_paid_amount_decremented",
                        "payment_details_updated",
                        "all_payments_complete",
                        "subscription_cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "history_uid": {
                    "reference_type": "uuid",
                    "title": "History Uid",
                    "type": "string",
                    "uid_resource_type": "loan_history"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Uid",
                    "type": "string",
                    "uid_resource_type": "loan"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "payload_json": {
                    "additionalProperties": {},
                    "title": "Payload Json",
                    "type": "object"
                }
            },
            "required": [
                "entry_type",
                "history_uid",
                "loan_uid",
                "payload_json"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _LOAN_PAYMENT_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/LoanPaymentLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "LoanPaymentLogSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_paid_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount Paid In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Uid",
                    "type": "string",
                    "uid_resource_type": "loan"
                },
                "log_uid": {
                    "reference_type": "uuid",
                    "title": "Log Uid",
                    "type": "string",
                    "uid_resource_type": "loan_payment_log"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "period_index": {
                    "format": "integer",
                    "title": "Period Index",
                    "type": "number"
                },
                "stripe_invoice_id": {
                    "title": "Stripe Invoice Id",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_paid_in_cents",
                "loan_uid",
                "log_uid",
                "period_index",
                "stripe_invoice_id"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _LOAN_SYSTEM_INFO_JSON_SCHEMA = {
    "$ref": "#/definitions/LoanSystemInfoSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "LoanSystemInfoSchema": {
            "additionalProperties": false,
            "properties": {
                "accepted_count": {
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": -9223372036854775807,
                    "title": "Accepted Count",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "cut_off_total_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Cut Off Total In Cents",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_info_uid": {
                    "title": "Loan Info Uid",
                    "type": "string"
                },
                "loans_are_auto_approved": {
                    "title": "Loans Are Auto Approved",
                    "type": "boolean"
                },
                "loans_are_disabled": {
                    "title": "Loans Are Disabled",
                    "type": "boolean"
                },
                "rejected_count": {
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": -9223372036854775807,
                    "title": "Rejected Count",
                    "type": "number"
                },
                "total_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total In Cents",
                    "type": "number"
                },
                "use_cut_off_total_checks": {
                    "title": "Use Cut Off Total Checks",
                    "type": "boolean"
                }
            },
            "required": [
                "accepted_count",
                "created_timestamp",
                "cut_off_total_in_cents",
                "last_updated_timestamp",
                "loan_info_uid",
                "loans_are_auto_approved",
                "loans_are_disabled",
                "rejected_count",
                "total_in_cents",
                "use_cut_off_total_checks"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PAYMENT_REQUEST_JSON_SCHEMA = {
    "$ref": "#/definitions/PaymentRequestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PaymentRequestSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 1,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "marked_as_processed_timestamp": {
                    "format": "date-time",
                    "title": "Marked As Processed Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "request_uid": {
                    "reference_type": "uuid",
                    "title": "Request Uid",
                    "type": "string",
                    "uid_resource_type": "payment_request"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "state": {
                    "class_name": "PaymentRequestState",
                    "enum": [
                        "pending",
                        "processed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "description",
                "last_updated_timestamp",
                "marked_as_processed_timestamp",
                "request_uid",
                "resource_type",
                "resource_uid",
                "state"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PRIORITY_ACH_PAYMENT_JSON_SCHEMA = {
    "$ref": "#/definitions/PriorityACHPaymentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PriorityACHPaymentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_number": {
                    "maxLength": 17,
                    "minLength": 6,
                    "title": "Account Number",
                    "type": "string"
                },
                "account_type": {
                    "class_name": "BankAccountType",
                    "enum": [
                        "checking",
                        "savings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "admin_review_account_uid": {
                    "reference_type": "uuid",
                    "title": "Admin Review Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "admin_review_complete": {
                    "title": "Admin Review Complete",
                    "type": "boolean"
                },
                "admin_review_timestamp": {
                    "format": "date-time",
                    "title": "Admin Review Timestamp",
                    "type": "string"
                },
                "bad_details_info": {
                    "class_name": "ACHBadDetails",
                    "enum": [
                        "bad_details",
                        "bad_name_on_account",
                        "bad_account_number",
                        "bad_routing_number"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "clear_into_funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "clear_into_funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Clear Into Funds Location Uid",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "details_are_bad": {
                    "title": "Details Are Bad",
                    "type": "boolean"
                },
                "details_hash": {
                    "title": "Details Hash",
                    "type": "string"
                },
                "fees_total_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Fees Total In Cents",
                    "type": "number"
                },
                "flagged_for_admin_review": {
                    "title": "Flagged For Admin Review",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "name_on_account": {
                    "title": "Name On Account",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "payment_cleared_into_deposify_bank_account": {
                    "title": "Payment Cleared Into Deposify Bank Account",
                    "type": "boolean"
                },
                "payment_succeeded": {
                    "title": "Payment Succeeded",
                    "type": "boolean"
                },
                "payment_uid": {
                    "reference_type": "uuid",
                    "title": "Payment Uid",
                    "type": "string",
                    "uid_resource_type": "priority_ach_payment"
                },
                "priority_return_payload": {
                    "additionalProperties": {},
                    "title": "Priority Return Payload",
                    "type": "object"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "routing_number": {
                    "maxLength": 9,
                    "minLength": 9,
                    "title": "Routing Number",
                    "type": "string"
                },
                "state": {
                    "class_name": "ACHPaymentState",
                    "enum": [
                        "awaiting_clearance",
                        "cleared",
                        "did_not_clear",
                        "payment_failed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "total_payment_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total Payment In Cents",
                    "type": "number"
                }
            },
            "required": [
                "account_number",
                "account_type",
                "account_uid",
                "admin_review_account_uid",
                "admin_review_complete",
                "admin_review_timestamp",
                "bad_details_info",
                "clear_into_funds_location",
                "clear_into_funds_location_uid",
                "details_are_bad",
                "details_hash",
                "fees_total_in_cents",
                "flagged_for_admin_review",
                "name_on_account",
                "payment_cleared_into_deposify_bank_account",
                "payment_succeeded",
                "payment_uid",
                "priority_return_payload",
                "resource_type",
                "resource_uid",
                "routing_number",
                "state",
                "total_payment_in_cents"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PRIORITY_ACH_RECURRING_PAYMENT_JSON_SCHEMA = {
    "$ref": "#/definitions/PriorityACHRecurringPaymentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PriorityACHRecurringPaymentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_number": {
                    "maxLength": 17,
                    "minLength": 6,
                    "title": "Account Number",
                    "type": "string"
                },
                "account_type": {
                    "class_name": "BankAccountType",
                    "enum": [
                        "checking",
                        "savings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_ach_payment_uid": {
                    "reference_type": "uuid",
                    "title": "Last Ach Payment Uid",
                    "type": "string",
                    "uid_resource_type": "priority_ach_payment"
                },
                "last_payment_timestamp": {
                    "format": "date-time",
                    "title": "Last Payment Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "loan_uid": {
                    "reference_type": "uuid",
                    "title": "Loan Uid",
                    "type": "string",
                    "uid_resource_type": "loan"
                },
                "name_on_account": {
                    "title": "Name On Account",
                    "type": "string"
                },
                "next_payment_timestamp": {
                    "format": "date-time",
                    "title": "Next Payment Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "recurring_payment_uid": {
                    "reference_type": "uuid",
                    "title": "Recurring Payment Uid",
                    "type": "string",
                    "uid_resource_type": "priority_ach_recurring_payment"
                },
                "routing_number": {
                    "maxLength": 9,
                    "minLength": 9,
                    "title": "Routing Number",
                    "type": "string"
                },
                "state": {
                    "class_name": "ACHRecurringPaymentState",
                    "enum": [
                        "pending",
                        "active",
                        "payment_details_needed",
                        "disabled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_number",
                "account_type",
                "account_uid",
                "amount_in_cents",
                "last_ach_payment_uid",
                "last_payment_timestamp",
                "loan_uid",
                "name_on_account",
                "next_payment_timestamp",
                "recurring_payment_uid",
                "routing_number",
                "state"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _SEZZLE_ORDER_JSON_SCHEMA = {
    "$ref": "#/definitions/SezzleOrderSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "SezzleOrderSchema": {
            "additionalProperties": false,
            "properties": {
                "account_credited": {
                    "title": "Account Credited",
                    "type": "boolean"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "cancelled_timestamp": {
                    "format": "date-time",
                    "title": "Cancelled Timestamp",
                    "type": "string"
                },
                "checkout_url": {
                    "title": "Checkout Url",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "fee_reference": {
                    "title": "Fee Reference",
                    "type": "string"
                },
                "fees_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Fees In Cents",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "paid_timestamp": {
                    "format": "date-time",
                    "title": "Paid Timestamp",
                    "type": "string"
                },
                "reference_uid": {
                    "title": "Reference Uid",
                    "type": "string"
                },
                "refunded_timestamp": {
                    "format": "date-time",
                    "title": "Refunded Timestamp",
                    "type": "string"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "sezzle_order_uid": {
                    "reference_type": "uuid",
                    "title": "Sezzle Order Uid",
                    "type": "string",
                    "uid_resource_type": "sezzle_order"
                },
                "sezzle_session_uid": {
                    "title": "Sezzle Session Uid",
                    "type": "string"
                },
                "state": {
                    "class_name": "SezzleOrderState",
                    "enum": [
                        "pending",
                        "cancelled",
                        "complete",
                        "refunded",
                        "cancelled_due_to_inactivity"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_credited",
                "account_uid",
                "amount_in_cents",
                "cancelled_timestamp",
                "checkout_url",
                "created_timestamp",
                "deposify_tags",
                "fee_reference",
                "fees_in_cents",
                "last_updated_timestamp",
                "notes_uid",
                "paid_timestamp",
                "reference_uid",
                "refunded_timestamp",
                "resource_type",
                "resource_uid",
                "sezzle_order_uid",
                "sezzle_session_uid",
                "state"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _SEZZLE_WEBHOOK_EVENT_JSON_SCHEMA = {
    "$ref": "#/definitions/SezzleWebhookEventSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "SezzleWebhookEventSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "data_type": {
                    "title": "Data Type",
                    "type": "string"
                },
                "data_uid": {
                    "title": "Data Uid",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "event": {
                    "title": "Event",
                    "type": "string"
                },
                "event_json": {
                    "additionalProperties": {},
                    "title": "Event Json",
                    "type": "object"
                },
                "event_uid": {
                    "reference_type": "uuid",
                    "title": "Event Uid",
                    "type": "string",
                    "uid_resource_type": "sezzle_webhook_event"
                },
                "ignored": {
                    "title": "Ignored",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "processed": {
                    "title": "Processed",
                    "type": "boolean"
                },
                "processed_info": {
                    "additionalProperties": {},
                    "title": "Processed Info",
                    "type": "object"
                }
            },
            "required": [
                "data_type",
                "data_uid",
                "event",
                "event_json",
                "event_uid",
                "ignored",
                "processed",
                "processed_info"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _STRIPE_PAYMENT_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/StripePaymentLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "StripePaymentLogSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "admin_review_account_uid": {
                    "reference_type": "uuid",
                    "title": "Admin Review Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "admin_review_complete": {
                    "title": "Admin Review Complete",
                    "type": "boolean"
                },
                "admin_review_timestamp": {
                    "format": "date-time",
                    "title": "Admin Review Timestamp",
                    "type": "string"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "clear_into_funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "clear_into_funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Clear Into Funds Location Uid",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "fees_total_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Fees Total In Cents",
                    "type": "number"
                },
                "flagged_for_admin_review": {
                    "title": "Flagged For Admin Review",
                    "type": "boolean"
                },
                "high_risk_payment": {
                    "title": "High Risk Payment",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "payment_cleared_into_deposify_bank_account": {
                    "title": "Payment Cleared Into Deposify Bank Account",
                    "type": "boolean"
                },
                "payment_log_uid": {
                    "reference_type": "uuid",
                    "title": "Payment Log Uid",
                    "type": "string",
                    "uid_resource_type": "stripe_payment_log"
                },
                "payment_request_uid": {
                    "reference_type": "uuid",
                    "title": "Payment Request Uid",
                    "type": "string",
                    "uid_resource_type": "payment_request"
                },
                "payment_succeeded": {
                    "title": "Payment Succeeded",
                    "type": "boolean"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "stripe_charge_payload": {
                    "additionalProperties": {},
                    "title": "Stripe Charge Payload",
                    "type": "object"
                },
                "stripe_error_info": {
                    "title": "Stripe Error Info",
                    "type": "string"
                },
                "stripe_token_payload": {
                    "additionalProperties": {},
                    "title": "Stripe Token Payload",
                    "type": "object"
                }
            },
            "required": [
                "account_uid",
                "admin_review_account_uid",
                "admin_review_complete",
                "admin_review_timestamp",
                "amount_in_cents",
                "clear_into_funds_location",
                "clear_into_funds_location_uid",
                "created_timestamp",
                "deposify_tags",
                "description",
                "fees_total_in_cents",
                "flagged_for_admin_review",
                "high_risk_payment",
                "last_updated_timestamp",
                "payment_cleared_into_deposify_bank_account",
                "payment_log_uid",
                "payment_request_uid",
                "payment_succeeded",
                "resource_type",
                "resource_uid",
                "stripe_charge_payload",
                "stripe_error_info",
                "stripe_token_payload"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _STRIPE_WEBHOOK_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/StripeWebhookLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "StripeWebhookLogSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "customer_id": {
                    "title": "Customer Id",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "event_id": {
                    "title": "Event Id",
                    "type": "string"
                },
                "event_json": {
                    "additionalProperties": {},
                    "title": "Event Json",
                    "type": "object"
                },
                "event_type": {
                    "title": "Event Type",
                    "type": "string"
                },
                "ignored": {
                    "title": "Ignored",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "log_uid": {
                    "reference_type": "uuid",
                    "title": "Log Uid",
                    "type": "string",
                    "uid_resource_type": "stripe_payment_log"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "process_after_timestamp": {
                    "format": "date-time",
                    "title": "Process After Timestamp",
                    "type": "string"
                },
                "processed": {
                    "title": "Processed",
                    "type": "boolean"
                },
                "processed_info": {
                    "additionalProperties": {},
                    "title": "Processed Info",
                    "type": "object"
                }
            },
            "required": [
                "customer_id",
                "event_id",
                "event_json",
                "event_type",
                "ignored",
                "log_uid",
                "process_after_timestamp",
                "processed",
                "processed_info"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_PAYMENT_PROVIDER_INFO_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountPaymentProviderInfoSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountPaymentProviderInfoSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "stripe_customer_id": {
                    "title": "Stripe Customer Id",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "stripe_customer_id"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_WITHDRAW_JSON_SCHEMA = {
    "$ref": "#/definitions/UserWithdrawSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserWithdrawSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 1,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "funds_lock_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Lock Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "show_user_payment_verification": {
                    "title": "Show User Payment Verification",
                    "type": "boolean"
                },
                "state": {
                    "class_name": "WithdrawState",
                    "enum": [
                        "pending",
                        "user_info_needed",
                        "payment_pending",
                        "payment_complete",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "user_bank_account_type": {
                    "class_name": "InternalUserBankAccountType",
                    "enum": [
                        "us_domestic",
                        "international"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "user_bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "User Bank Account Uid",
                    "type": "string"
                },
                "user_visible_payment_verification": {
                    "title": "User Visible Payment Verification",
                    "type": "string"
                },
                "withdraw_uid": {
                    "reference_type": "uuid",
                    "title": "Withdraw Uid",
                    "type": "string",
                    "uid_resource_type": "user_withdraw"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "deposify_tags",
                "funds_lock_uid",
                "last_updated_timestamp",
                "notes",
                "show_user_payment_verification",
                "state",
                "user_bank_account_type",
                "user_bank_account_uid",
                "user_visible_payment_verification",
                "withdraw_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const INVOICE_JSON_SCHEMA = _INVOICE_JSON_SCHEMA.definitions.InvoiceSchema;
export const INVOICE_ITEM_JSON_SCHEMA = _INVOICE_ITEM_JSON_SCHEMA.definitions.InvoiceItemSchema;
export const LOAN_JSON_SCHEMA = _LOAN_JSON_SCHEMA.definitions.LoanSchema;
export const LOAN_APPLICATION_JSON_SCHEMA = _LOAN_APPLICATION_JSON_SCHEMA.definitions.LoanApplicationSchema;
export const LOAN_HISTORY_JSON_SCHEMA = _LOAN_HISTORY_JSON_SCHEMA.definitions.LoanHistorySchema;
export const LOAN_PAYMENT_LOG_JSON_SCHEMA = _LOAN_PAYMENT_LOG_JSON_SCHEMA.definitions.LoanPaymentLogSchema;
export const LOAN_SYSTEM_INFO_JSON_SCHEMA = _LOAN_SYSTEM_INFO_JSON_SCHEMA.definitions.LoanSystemInfoSchema;
export const PAYMENT_REQUEST_JSON_SCHEMA = _PAYMENT_REQUEST_JSON_SCHEMA.definitions.PaymentRequestSchema;
export const PRIORITY_ACH_PAYMENT_JSON_SCHEMA = _PRIORITY_ACH_PAYMENT_JSON_SCHEMA.definitions.PriorityACHPaymentSchema;
export const PRIORITY_ACH_RECURRING_PAYMENT_JSON_SCHEMA = _PRIORITY_ACH_RECURRING_PAYMENT_JSON_SCHEMA.definitions.PriorityACHRecurringPaymentSchema;
export const SEZZLE_ORDER_JSON_SCHEMA = _SEZZLE_ORDER_JSON_SCHEMA.definitions.SezzleOrderSchema;
export const SEZZLE_WEBHOOK_EVENT_JSON_SCHEMA = _SEZZLE_WEBHOOK_EVENT_JSON_SCHEMA.definitions.SezzleWebhookEventSchema;
export const STRIPE_PAYMENT_LOG_JSON_SCHEMA = _STRIPE_PAYMENT_LOG_JSON_SCHEMA.definitions.StripePaymentLogSchema;
export const STRIPE_WEBHOOK_LOG_JSON_SCHEMA = _STRIPE_WEBHOOK_LOG_JSON_SCHEMA.definitions.StripeWebhookLogSchema;
export const USER_ACCOUNT_PAYMENT_PROVIDER_INFO_JSON_SCHEMA = _USER_ACCOUNT_PAYMENT_PROVIDER_INFO_JSON_SCHEMA.definitions.UserAccountPaymentProviderInfoSchema;
export const USER_WITHDRAW_JSON_SCHEMA = _USER_WITHDRAW_JSON_SCHEMA.definitions.UserWithdrawSchema;
